import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "peach3d_favorites";

function readFavorites(): string[] {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as string[]) : [];
  } catch {
    return [];
  }
}

export function useFavorites() {
  const [favorites, setFavorites] = useState<string[]>([]);

  useEffect(() => {
    setFavorites(readFavorites());
  }, []);

  const persist = useCallback((next: string[]) => {
    setFavorites(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      // ignore storage failures in demo mode
    }
  }, []);

  const toggle = useCallback(
    (id: string) => {
      const current = readFavorites();
      const next = current.includes(id)
        ? current.filter((item) => item !== id)
        : [...current, id];
      persist(next);
      return next.includes(id);
    },
    [persist],
  );

  const isFavorite = useCallback((id: string) => favorites.includes(id), [favorites]);

  return { favorites, toggle, isFavorite };
}